import { useMemo, useState } from 'react'

import { Button, Grid } from '@mui/material'

import { CardTitle, TextInput } from 'components/common'
import SwitchDriverRoleDialog from 'components/common/Driver/SwitchDriverRole'
import { useGetDriverIdentityRoleQuery } from 'generated/graphql'

interface IIDentityDetails {
  driverId: number | undefined
}

const IdentityDetails = ({ driverId }: IIDentityDetails) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  const { loading, data } = useGetDriverIdentityRoleQuery({
    variables: {
      driverId,
    },
    skip: !driverId,
  })

  const currentRole = useMemo(() => {
    if (data?.driver?.role && data.driver.role.length > 0) {
      return data.driver.role[0]
    }
    return ''
  }, [data])

  const handleOpenDialog = () => setOpenDialog(true)
  const handleCloseDialog = () => setOpenDialog(false)

  return (
    <Grid container item spacing={1} xs={12}>
      <Grid xs={12}>
        <CardTitle>Identity Details</CardTitle>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextInput readOnly label='Username' value={data?.driver?.identityUserName} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextInput readOnly label='Role' value={currentRole} />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Button
          disabled={loading || !data?.driver?.role}
          variant='contained'
          color='grey'
          onClick={handleOpenDialog}>
          Change role
        </Button>
      </Grid>

      {!loading && driverId && openDialog && (
        <SwitchDriverRoleDialog
          handleCloseDialog={handleCloseDialog}
          driverRole={currentRole}
          openDialog={openDialog}
          driverId={driverId}
        />
      )}
    </Grid>
  )
}

export default IdentityDetails
